import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { ACTION_TYPE_INSURE_PACKAGE } from '../../../../settings/automation-rules/constants/action-types';
import { InsuranceProviders } from '../../../../../enums/insurance-providers';
import Global from '../../../../../store/global-selectors';
import { US } from '../../../../../constants/country-codes';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import type { PreconfiguredRule } from '../automation-playbook-types';
import { AutomationPlaybooks } from '../playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const INSURANCE_RULE: PreconfiguredRule = {
  active: true,
  isNew: true,
  isTemplate: true,
  playbook: AutomationPlaybooks.InsureHighValueOrders,
  ruleName: messages.insureOrdersRuleName,
  filterConditions: [{ fieldType: 'OrderTotal', operator: 'greaterThan', value: '', logicalOperator: 'AND' }],
  orderRuleActions: [{ actionTypeId: ACTION_TYPE_INSURE_PACKAGE, parameter: null, isDeleted: false }],
};

export const InsuranceRuleCard: React.FC = () => {
  const intl = useIntl();
  const openRuleEditor = useOpenRuleEditor();
  const isUsSeller = useSelector(Global.selectSellerHomeCountry) === US;
  const insuranceProvider = isUsSeller ? InsuranceProviders.ParcelGuard : InsuranceProviders.XCover;
  const handleClick = useCallback(() => openRuleEditor(INSURANCE_RULE), [openRuleEditor]);
  const titleValues = useMemo(
    () => ({ insuranceProvider: intl.formatMessage(insuranceProvider.messageDescriptor) }),
    [intl, insuranceProvider],
  );

  return (
    <PlaybookCard
      description={messages.insureOrdersDescription}
      glyph='shield'
      onClick={handleClick}
      title={messages.insureOrdersTitle}
      titleValues={titleValues}
    />
  );
};
